<template>
  <g-popup title="Account ID / Subscription ID  목록" width="645" :background-click="false">
    <template #body>
      <div class="-font-size-12" style="width: 100%">
        <ag-grid-vue
          style="height: 300px;width: 100%"
          class="ag-theme-balham"
          row-height="30"
          header-height="30"
          :columnDefs="columnDefs"
          :rowData="cspAccountList">
        </ag-grid-vue>
      </div>
    </template>
    <template #footer>
      <g-button variant="primary" @click="onClickConfirm"><span>확인</span></g-button>
    </template>
  </g-popup>
</template>
<script>

import { AgGridVue } from 'ag-grid-vue';
import AgGridMixin from '@/pages/mixin/AgGrid.mixin'
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'constractDetailPopup',
  components: {
    AgGridVue
  },
  mixins: [AgGridMixin()],
  props: {
    instKey: {
      type: String,
      default: null
    },
    companyCode: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    month: {
      type: String,
      default: null
    },
    prodId: {
      type: String,
      default: null
    },
  },
  computed: {
    ...mapGetters('contract', ['cspAccountList'])
  },
  methods: {
    ...mapActions('contract', ['getCSPAccountId']),
    onClickConfirm () {
      this.$popupManager.close(this.instKey)
      if (this.onConfirm) {
        this.onConfirm()
      }
    },
    setColumn () {
      this.columnDefs = [
        {
          headerName:  this.$t('pages_contract_ContractInfo.column.headerName.no') ,
          field: "rowId",
          width: 100,
          unSortIcon: false,
          resizable: true
        },
        {
          headerName:  this.$t('pages_contract_ContractInfo.column.headerName.accountId') ,
          field: "svcId",
          width: 200,
          unSortIcon: false,
          resizable: true
        },
        {
          headerName:  this.$t('pages_contract_ContractInfo.column.headerName.payment') ,
          field: "totalAmount",
          width: 300,
          unSortIcon: false,
          resizable: true
        }
      ];
      this.fitGrid()
    }
  },
  mounted() {
    this.getCSPAccountId({companyCode: this.companyCode, id: this.id, month: this.month, prodId: this.prodId})
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/pages/contract/components/components/ConstractDetailPopup.vue